import { CreateVendorPaymentParam, GetAllVendorPaymentByVendorIdParam, GetVendorPaymentsByVendorIdByDateRangeParam } from '@resident-select/domain/vendor-payment';
import { GetAllBookingsByVendorAndStatusParam, GetBookingsByVendorPaymentIdByDateRangeParam } from '@resident-select/domain/booking';
import { createEntityCommand } from '../../../shared/base';

export const GetAllVendorPaymentByVendorIdCommand = createEntityCommand<GetAllVendorPaymentByVendorIdParam>('GetAllVendorPaymentByVendorIdCommand');

export const CreateVendorPaymentCommand = createEntityCommand<CreateVendorPaymentParam>('CreateVendorPaymentCommand');

export const GetAllBookingsByVendorAndStatusCommand = createEntityCommand<GetAllBookingsByVendorAndStatusParam>('GetAllBookingsByVendorAndStatusCommand');

export const GetBookingsByVendorPaymentIdByDateRangeCommand = createEntityCommand<GetBookingsByVendorPaymentIdByDateRangeParam>('GetBookingsByVendorPaymentIdByDateRangeCommand');

export const GetVendorPaymentsByVendorIdByDateRangeCommand = createEntityCommand<GetVendorPaymentsByVendorIdByDateRangeParam>('GetVendorPaymentsByVendorIdByDateRangeCommand');
